// src/web-app/lib/auth/secureStore.js
// Web app uses localStorage (no Tauri)
const NAMESPACE = "footcheck";

const browserStorage = {
  async set(key, value) {
    try {
      localStorage.setItem(`${NAMESPACE}/${key}`, value);
    } catch (e) {
      console.error("Failed to save to localStorage:", e);
      throw e;
    }
  },
  
  async get(key) {
    try {
      return localStorage.getItem(`${NAMESPACE}/${key}`) || null;
    } catch (e) {
      console.error("Failed to read from localStorage:", e);
      return null;
    }
  },
  
  async delete(key) {
    try {
      localStorage.removeItem(`${NAMESPACE}/${key}`);
    } catch (e) {
      console.error("Failed to delete from localStorage:", e);
    }
  }
};

export async function secureSet(key, value) {
  await browserStorage.set(key, value);
}

export async function secureGet(key) {
  return await browserStorage.get(key);
}

export async function secureDelete(key) {
  await browserStorage.delete(key);
}






